<template>
  <div id="summaryIndex" class="summaryIndex">
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Summary')">
        <span class="item-name">下单信息</span>
        <i :class="{ 'el-icon-arrow-down': !summaryShow, 'el-icon-arrow-up': summaryShow}" />
      </div>
      <div v-if="summaryShow" class="list-card margin-top_10">
        <Summary ref="Summary" />
      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Cargo')">
        <span class="item-name">商品信息</span>
        <i :class="{ 'el-icon-arrow-down': !cargoShow, 'el-icon-arrow-up': cargoShow}" />
      </div>
      <div v-if="cargoShow" class="file-table margin-top_10">
        <table class="table">
          <thead>
            <tr>
              <th>箱号</th>
              <th>品名</th>
              <th>海关编码</th>
              <th>数量</th>
              <th>申报价值</th>
              <th>材质</th>
              <th>用途</th>
              <th>FBANO</th>
              <th>ReID</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in cargoList" :key="index">
              <td>{{ item.cartonNo }}</td>
              <td>{{ item.nameCh }}</td>
              <td>{{ item.customlabel }}</td>
              <td>{{ item.quantity }}</td>
              <td>单价{{ item.unitPrice }}USD|合计{{ item.totalPrice }}USD</td>
              <td>{{ item.material }}</td>
              <td>{{ item.purpose }}</td>
              <td>{{ item.fbaNo }}</td>
              <td>{{ item.reId }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Volume')">
        <span class="item-name">材积信息</span>
        <i :class="{ 'el-icon-arrow-down': !volumeShow, 'el-icon-arrow-up': volumeShow}" />
      </div>
      <div v-if="volumeShow" class="grid-container">
        <div class="grid-item" />
        <div class="grid-item">箱数</div>
        <div class="grid-item">实重(KG)</div>
        <div class="grid-item">体积(CBM)</div>
        <div class="grid-item">体积重(KG)</div>
        <div class="grid-item">计费重(KG)</div>
        <div class="grid-item">预报</div>
        <div class="grid-item">{{ volumeForecastActual.forecast?volumeForecastActual.forecast.Quantity:'-' }}</div>
        <div class="grid-item">{{ volumeForecastActual.forecast?volumeForecastActual.forecast.Weight:'-' }}</div>
        <div class="grid-item">{{ volumeForecastActual.forecast?volumeForecastActual.forecast.Volume:'-' }}</div>
        <div class="grid-item">{{ volumeForecastActual.forecast?volumeForecastActual.forecast.VolumeWeight:'-' }}</div>
        <div class="grid-item">{{ volumeForecastActual.forecast?volumeForecastActual.forecast.ChargeWeight:'-' }}</div>
        <div class="grid-item">实收</div>
        <div class="grid-item">{{ volumeForecastActual.actual?volumeForecastActual.actual.Quantity:'-' }}</div>
        <div class="grid-item">{{ volumeForecastActual.actual?volumeForecastActual.actual.Weight:'-' }}</div>
        <div class="grid-item">{{ volumeForecastActual.actual?volumeForecastActual.actual.Volume :'-' }}</div>
        <div class="grid-item">{{ volumeForecastActual.actual?volumeForecastActual.actual.VolumeWeight:'-' }}</div>
        <div class="grid-item">{{ volumeForecastActual.actual?volumeForecastActual.actual.ReceiveChargeWeight:'-' }}</div>
      </div>
      <div v-if="volumeShow" class="file-table margin-top_10">
        <table v-if="volume.margeList&&volume.margeList.length>0" class="table">
          <thead>
            <tr>
              <th>箱号</th>
              <th>预报-长x宽x高(CM) | 实量(KG)</th>
              <th>预报件数</th>
              <th>收货-长x宽x高(CM) | 实量(KG)</th>
              <th>收货件数</th>
              <th>围长(CM)</th>
              <th>子单号</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in volume.margeList" :key="index">
              <td>{{ item.cartonNo }}</td>
              <td>{{ item.length }}x{{ item.width }}x{{ item.height }} | {{ item.weight }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.receiveLength }}x{{ item.receiveWidth }}x{{ item.receiveHeight }} | {{ item.receiveWeight }}</td>
              <td>{{ item.receiveQuantity }}</td>
              <td>{{ item.girth }}</td>
              <td>{{ item.subTrackNo }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <table v-if="volume.customerList&&volume.customerList.length>0" class="table">
            <tr>
              <td>箱号</td>
              <td>预报-长x宽x高(CM) | 实量(KG)</td>
              <td>预报件数</td>
              <td>围长(CM)</td>
              <td>子单号</td>
            </tr>
            <tr v-for="(item,index) in volume.customerList" :key="index">
              <td>{{ item.cartonNo }}</td>
              <td>{{ item.length }}x{{ item.width }}x{{ item.height }} | {{ item.weight }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.girth }}</td>
              <td>{{ item.subTrackNo }}</td>
            </tr>
          </table>
          <table v-if="volume.receiveList&&volume.receiveList.length>0" class="table">
            <tr>
              <td>箱号</td>
              <td>收货-长x宽x高(CM) | 实量(KG)</td>
              <td>收货件数</td>
              <td>围长(CM)</td>
              <td>子单号</td>
            </tr>
            <tr v-for="(item,index) in volume.receiveList" :key="index">
              <td>{{ item.cartonNo }}</td>
              <td>{{ item.length }}x{{ item.width }}x{{ item.height }} | {{ item.weight }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.girth }}</td>
              <td>{{ item.subTrackNo }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Documents')">
        <span class="item-name">订单附件</span>
        <i :class="{ 'el-icon-arrow-down': !documentsShow, 'el-icon-arrow-up': documentsShow}" />
      </div>
      <div v-if="documentsShow" class="list-card margin-top_10">
        <Documents ref="Documents" />
      </div>
    </div>

    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Contacts')">
        <span class="item-name">订单联系人</span>
        <i :class="{ 'el-icon-arrow-down': !contactsShow, 'el-icon-arrow-up': contactsShow}" />
      </div>
      <div v-if="contactsShow" class="list-card margin-top_10">
        <Contacts ref="Contacts" />
      </div>
    </div>
  </div>
</template>

<script>
import Summary from './Summary.vue'
import Documents from './documents.vue'
import Contacts from './Contacts.vue'
import TransitInfo from './TransitInfo.vue'
import request from '@/utils/request'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'SummaryIndex',
  components: {
    // 组件的引用
    Summary,
    Documents,
    TransitInfo,
    Contacts
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      token: '',
      list: [{
        name: 'Transit Information',
        isTrue: false,
        type: 'TransitInfo',
        disaled: true
      },
      {
        name: 'Documents',
        isTrue: false,
        type: 'Documents',
        disaled: true
      },
      {
        name: 'Summary',
        isTrue: true,
        type: 'Summary',
        disaled: false
      },
      {
        name: 'Consignor And Consignee',
        isTrue: false,
        type: 'Contacts',
        disaled: true
      }
      ],
      data: {},
      selectList: [],
      transitInfoEabled: false,
      documentsEabled: false,
      contactsEabled: false,
      transitShow: false,
      documentsShow: false,
      contactsShow: false,
      summaryShow: true,
      cargoShow: false,
      volumeShow: true,
      cargoList: [],
      volume: {},
      volumeForecastActual: {
        forecast: undefined,
        actual: undefined
      }
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    this.token = getCookie('token')
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.data = data
      if (data.status > 1 && data.status < 7) {
        this.transitInfoEabled = true
        this.documentsEabled = true
        this.contactsEabled = true
      } else {
        this.transitInfoEabled = false
        this.documentsEabled = false
        this.contactsEabled = false
      }
      this.$nextTick(() => {
        this.$refs.Summary.init(data)
      })
      this.getCargoList()
      this.getVolumeList()
      this.getOrderVolumeInfo()
    },
    getCargoList() {
      request({
        url: `/api/wms/operate/order/getcargo/${this.data.orderNo}`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.cargoList = res.data
      })
    },
    getVolumeList() {
      request({
        url: `/api/webapi/order/GetVolumeList/${this.data.orderNo}`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.volume = res.data
      })
    },
    getOrderVolumeInfo() {
      request({
        url: `/api/wms/Volume/GetOrderForecastActual/${this.data.orderNo}`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.volumeForecastActual = res.data
      })
    },
    clkxShow(type) {
      switch (type) {
        case 'TransitInfo':
          if (this.transitInfoEabled) {
            this.transitShow = !this.transitShow
            if (this.transitShow) {
              this.$nextTick(() => {
                this.$refs.TransitInfo.init(this.data)
              })
            }
          }
          break
        case 'Documents':
          if (this.transitInfoEabled) {
            this.documentsShow = !this.documentsShow
            if (this.documentsShow) {
              this.$nextTick(() => {
                this.$refs.Documents.init(this.data)
              })
            }
          }
          break
        case 'Summary':
          if (this.transitInfoEabled) {
            this.summaryShow = !this.summaryShow
            if (this.summaryShow) {
              this.$nextTick(() => {
                this.$refs.Summary.init(this.data)
              })
            }
          }
          break
        case 'Contacts':
          if (this.transitInfoEabled) {
            this.contactsShow = !this.contactsShow
            if (this.contactsShow) {
              this.$nextTick(() => {
                this.$refs.Contacts.init(this.data)
              })
            }
          }
          break
        case 'Cargo':
          this.cargoShow = !this.cargoShow
          break
        case 'Volume':
          this.volumeShow = !this.volumeShow
          break
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.summaryIndex {
		width: 1200px;
		height: auto;
		background: #FFFFFF;
		border-radius: 8px;
		margin-top: 16px;
    padding: 20px;
    box-sizing: border-box;

    .list-bj:nth-child(1){
      margin-top: 0px;
    }

		.list-bj {
      margin-top: 20px;
			.list-item {
				cursor: pointer;
				text-align: left;
				display: flex;
				align-items: center;

				.red-tip {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 156px;
					height: 24px;
					background: rgba(239, 10, 10, 0.04);
					border-radius: 12px;
					margin-left: 16px;

					span {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #EF0A0A;
						margin-left: 4px;
					}
				}

				.item-name {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #000000;
          padding-left: 10px;
          position: relative;
          margin-right: 5px;

				}
        .item-name:before{
            content: "";
            position: absolute;
            left: 0;
            top: 5px;
            width: 4px;
            height: 60%;
            background-color: #436FF6;
            border-radius: 10px;
        }
			}

      .grid-container {
          display: grid;
          grid-template-rows: repeat(3, 1fr);
          grid-template-columns: repeat(6, 1fr);
          gap: 2px;
          border-radius: 10px;
          overflow: hidden;
          width: 100%;
          margin: 20px auto;

          .grid-item:nth-child(2),
          .grid-item:nth-child(3),
          .grid-item:nth-child(4),
          .grid-item:nth-child(5),
          .grid-item:nth-child(6),
          .grid-item:nth-child(7),
          .grid-item:nth-child(13){
              color: #32343C;
          }

          .grid-item {
              background-color: #F5F6F8;
              padding: 15px;
              text-align: center;
              font-size: 14px;
              color: #777777;
          }
      }

		}

		.file-table {
			text-align: center;

			.table {
				overflow: hidden;
				box-shadow: 0 0 0 1px #F0F1F2;
				border-radius: 8px;
				width: 100%;
				border-collapse: collapse;

				tr:nth-of-type(1) {
					th {
						height: 70px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						color: #333333;
						background: #F5F6F9;
						width: 200px;
					}
				}

				tr {

					td {
						height: 60px;
						padding: 0 4px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						width: 200px;

						.division-line {
							display: inline-block;
							height: 20px;
							width: 100%;
							border-right: 1px solid #DDDDDD;
						}

						.blue {
							color: #027FFC;
							cursor: pointer;
						}
					}
				}
			}
		}

	}
</style>
